import { render, staticRenderFns } from "./OpenRtaList.vue?vue&type=template&id=713fe6cc&scoped=true&"
import script from "./OpenRtaList.vue?vue&type=script&lang=js&"
export * from "./OpenRtaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713fe6cc",
  null
  
)

export default component.exports